import { render, staticRenderFns } from "./PlanBenefitsList.vue?vue&type=template&id=2056e558&"
import script from "./PlanBenefitsList.vue?vue&type=script&lang=js&"
export * from "./PlanBenefitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports